
/*
 * THE APPLIANCE BARN
 * Klarna On-Site Messaging price synchronisation
 * Reads the selected variant price from the premium PDP.
 */
(() => {
  if (window.__abKlarnaSyncLoaded) return;
  window.__abKlarnaSyncLoaded = true;

  let lastAmount = null;
  let refreshTimer = null;

  function syncKlarna() {
    const panel = document.querySelector('[data-ab-pdp]');
    if (!panel) return;

    const amount = Number(panel.dataset.price);
    const isEnquiry = panel.dataset.priceRequest === 'true';

    if (!Number.isFinite(amount) || amount <= 0 || isEnquiry) {
      document.querySelectorAll('klarna-placement').forEach(el => {
        el.style.display = 'none';
      });
      return;
    }

    const placements = document.querySelectorAll('klarna-placement');
    if (!placements.length) return;

    const changed = lastAmount !== amount ||
      [...placements].some(el =>
        el.getAttribute('data-purchase-amount') !== String(amount)
      );

    placements.forEach(el => {
      el.style.display = '';
      el.setAttribute('data-purchase-amount', String(amount));
    });

    if (changed) {
      lastAmount = amount;

      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        if (window.Klarna?.OnsiteMessaging?.refresh) {
          window.Klarna.OnsiteMessaging.refresh();
        }
      }, 100);
    }
  }

  document.addEventListener('DOMContentLoaded', syncKlarna);
  document.addEventListener('variant:change', () => {
    setTimeout(syncKlarna, 50);
  });
  document.addEventListener('variant:update', () => {
    setTimeout(syncKlarna, 50);
  });

  // Handles Klarna loading later and custom panel updates.
  setInterval(syncKlarna, 500);

  syncKlarna();
})();
